import React from 'react';
import ReactAsyncSelect from 'react-select/async';
import { customStyles, DropdownIndicator, SMETheme } from '../Select.jsx';
import useProjectOptions from './hooks/useProjectOptions.js'

function ProjectSelect({
  name,
  queryKey,
  value: propsValue,
  label: propsLabel,
  onChange = () => {},
  reset = false,
  isDisabled = false,
  isClearable = false,
  readOnly = false,
  loadingMessage = 'Searching...',
  placeholder,
}) {
  const {value, setValue, loadOptions} = useProjectOptions({queryKey, propsValue, propsLabel, isDisabled, readOnly, reset})

  const handleChange = (v) => {
    setValue(v);
    onChange(v);
  }

  return (
    <ReactAsyncSelect
      name={name}
      value={value.value ? value : null}
      loadOptions={loadOptions}
      placeholder={placeholder}
      defaultOptions
      className={`react-select-bootstrap ${isDisabled && "disabled"}  ${readOnly && "readonly"}`}
      loadingMessage={() => loadingMessage}
      styles={customStyles}
      components={{DropdownIndicator: DropdownIndicator}}
      theme={SMETheme}
      onChange={handleChange}
      isDisabled={isDisabled || readOnly}
      isClearable={isClearable}
    />
  )
}

export default ProjectSelect;
